<div class="m-subheader">
    <div class="d-flex align-items-center">
        <div class="mr-auto">
            <h3 class="m-subheader__title m-subheader__title--separator">
                Add Existing Certification
            </h3>
        </div>
    </div>
</div>
<div class="m-content padding">
    <div class="m-content padding">
        <div class="m-portlet">
            <div class="m-portlet__body">
                <!-- Form Starts -->
                <div [formGroup]="cerificationUploadForm">
                    <!-- Form Feilds Starts -->
                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
								Sector:
								<span class="red">*</span>
							</label>
                        <div class="col-7">
                            <select class="form-control m-input" formControlName="sector" id="exampleSelect1" placeholder="Select Sector" [compareWith]="compareSectors" required>
									<option value="" disabled>Select Sector</option>
									<option [ngValue]="sector" (change)="getJobRoles(sector.id)" *ngFor="let sector of totalSectors">{{sector.name}}</option>
								</select>
                            <app-form-control-messages [control]="cerificationUploadForm.get('sector')" [name]="'Sector'"></app-form-control-messages>
                        </div>
                    </div>

                    <!-- <div class="form-group m-form__group row">
							<div class="col-1"></div>
							<label for="example-search-input" class="col-3 col-form-label">
								Sub Sector:
								<span class="red">*</span>
							</label>
							<div class="col-7">
								<select class="form-control m-input" formControlName="subSector" id="exampleSelect1" placeholder="Select Sub Sector" required
								 [compareWith]="compareSubSector" (change)="getJobRoles(null,null)">
									<option value="" disabled>Select Sub Sector</option>
									<option [ngValue]="subSector" *ngFor="let subSector of totalSubSectors">{{subSector.subSectorName}}</option>
								</select>
								<app-form-control-messages [control]="cerificationUploadForm.get('subSector')" [name]="'Sub Sector'"></app-form-control-messages>
							</div>
						</div> -->

                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
								Job Role (QP Code):
								<span class="red">*</span>
							</label>
                        <div class="col-7">
                            <select [compareWith]="compareJobRoleName" class="form-control m-input" formControlName="jobRole" id="exampleSelect1" placeholder="Select Sub Sector" required>
									<option value="" disabled>Select Job Role</option>
									<option [ngValue]="jobRole" *ngFor="let jobRole of totalJobRoles">{{jobRole.jobroleName}}</option>
								</select>
                            <app-form-control-messages [control]="cerificationUploadForm.get('jobRole')" [name]="'Job Role'"></app-form-control-messages>
                        </div>
                    </div>

                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
								Training Model:
								<span class="red">*</span>
							</label>
                        <div class="col-7">
                            <select [compareWith]="compareTrainingModel" class="form-control m-input" formControlName="trainingModel" id="exampleSelect1" placeholder="Select Training Mdoel" required>
									<option value="" disabled>Select Training Model</option>
									<option [ngValue]="training" *ngFor="let training of totalTrainingModels">{{training.name}}</option>
								</select>
                            <app-form-control-messages [control]="cerificationUploadForm.get('trainingModel')" [name]="'Training Model'"></app-form-control-messages>
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label class="col-3 col-form-label">
                            Country:
                            <span class="red">*</span>
                        </label>
                        <div class="col-7">
                            <div class="input-group">
                                <select [compareWith]="showCountry" class="form-control" formControlName="country">
                                    <option value="" disabled>Select Country</option>
                                    <option class="notranslate" *ngFor="let country of countries" [ngValue]="country">
                                        {{country.country}}</option>
                                </select>
                            </div>
                            <app-form-control-messages [control]="cerificationUploadForm.get('country')" [name]="'Country'"></app-form-control-messages>
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label class="col-3 col-form-label">
                            Batch Mode:
                            <span class="red">*</span>
                        </label>
                        <div class="col-7">
                            <div class="input-group">
                                <select [compareWith]="compareBatchMode" class="form-control" formControlName="batchMode">
                                    <option value="" disabled>Select Batch Mode</option>
                                    <option class="notranslate" *ngFor="let mode of batchMode" [ngValue]="mode.value">
                                        {{mode.value}}</option>
                                </select>
                            </div>
                            <app-form-control-messages [control]="cerificationUploadForm.get('batchMode')" [name]="'Batch Mode'"></app-form-control-messages>
                        </div>
                    </div>
                    <div class="form-group m-form__group row" *ngIf="showField">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
								State:
								<span class="red">*</span>
							</label>
                        <div class="col-7">
                            <select [compareWith]="compareStateAndDistrict" class="form-control m-input" formControlName="state" id="exampleSelect1" placeholder="Select Sub Sector" required>
									<option value="" disabled>Select State</option>
									<option [ngValue]="state" *ngFor="let state of totalStates">{{state.name}}</option>
								</select>
                            <app-form-control-messages [control]="cerificationUploadForm.get('state')" [name]="'State'"></app-form-control-messages>
                        </div>
                    </div>

                    <div class="form-group m-form__group row" *ngIf="showField">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
								District:
								<span class="red">*</span>
							</label>
                        <div class="col-7">
                            <select [compareWith]="compareStateAndDistrict" class="form-control m-input" formControlName="district" id="exampleSelect1" placeholder="Select district" required>
									<option value="" disabled>Select District</option>
									<option [ngValue]="district" *ngFor="let district of totalDistricts">{{district.name}}</option>
								</select>
                            <app-form-control-messages [control]="cerificationUploadForm.get('district')" [name]="'District'"></app-form-control-messages>
                        </div>
                    </div>

                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
								Certificate ID:
								<!-- <span class="red">*</span> -->
							</label>
                        <div class="col-7">
                            <input class="form-control m-input nameBackground" type="text" formControlName="certificateId" placeholder="Certificate Id">
                            <app-form-control-messages [control]="cerificationUploadForm.get('certificateId')" [name]="'Certificate ID'"></app-form-control-messages>
                        </div>
                    </div>

                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
								Certificate Issued On:
								<!-- <span class="red">*</span> -->
							</label>
                        <div class="col-7">
                            <input type="text" class="form-control m-input" (focusout)="assignednDate($event)" readonly="true" placeholder="Select Date" [id]="dateId1" formControlName="certificateIssueDate">
                        </div>
                    </div>

                    <!-- <div class="form-group m-form__group row">
							<div class="col-1"></div>
							<label for="example-search-input" class="col-3 col-form-label">
								Valid Till Date:
							</label>
							<div class="col-7">
								<input type="text" class="form-control m-input" disabled readonly="true" placeholder="Select Date" (focusout)="validTill($event)"
								 [id]="dateId2" formControlName="validTillDate">
							</div>
						</div> -->

                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
								Domain Percentage:
								<!-- <span class="red">*</span> -->
							</label>
                        <div class="col-7">
                            <input class="form-control m-input nameBackground" type="text" formControlName="domainPercentage" placeholder="Domain Percentage">
                            <app-form-control-messages [control]="cerificationUploadForm.get('domainPercentage')" [name]="'Domain Percentage'"></app-form-control-messages>
                        </div>
                    </div>

                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
								Platform Percentage:
								<!-- <span class="red">*</span> -->
							</label>
                        <div class="col-7">
                            <input class="form-control m-input nameBackground" type="text" formControlName="platformPercentage" placeholder="Platform Percentage">
                            <app-form-control-messages [control]="cerificationUploadForm.get('platformPercentage')" [name]="'Platform Percentage'"></app-form-control-messages>
                        </div>
                    </div>

                    <div class="form-group m-form__group row" *ngIf="showUpload == true && loginType !== 'SSC'">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
								Supporting Document:
								<!-- <span class="red">*</span> -->
							</label>
                        <!-- <div class="col-4">
				  <app-upload-file [formValue]="this.cerificationUploadForm.get('provisionalCertificate')" fileType="docURL1"
					[value]="docLink"  info="only jpg, png, jpeg, pdf"></app-upload-file>
					<input type="hidden" formControlName="provisionalCertificate" #fileInput>
				  <app-form-control-messages [control]="this.cerificationUploadForm.get('provisionalCertificate')">
				  </app-form-control-messages>
				</div> -->
                        <div class="col-sm-4">
                            <app-upload-file [formValue]="cerificationUploadForm.get('provisionalCertificate')" [(value)]="docLink" info="only jpg, png,jpeg, pdf" fileType="disabilityProof"></app-upload-file>
                            <input type="hidden" formControlName="provisionalCertificate" #fileInput>
                            <app-form-control-messages [control]="cerificationUploadForm.get('provisionalCertificate')" [name]="'Photo'"></app-form-control-messages>

                        </div>
                    </div>

                    <div class="form-group m-form__group row" *ngIf="showDownlod == true">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
								Download Supporting Document:
							</label>
                        <div class="col-4">
                            <app-file-download *ngIf="docLink !== ''" [fileURL]="docLink" [buttonText]="buttonText"></app-file-download>
                            <div *ngIf="docLink === ''" style="margin-top: 10px">NA</div>
                        </div>
                    </div>

                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
								Remarks to SSC:
								<!-- <span class="red">*</span> -->
							</label>
                        <div class="col-7">
                            <textarea name="" id="" class="form-control m-input" cols="100" rows="5" formControlName="remarkToSsc" placeholder="Enter Remarks to SSC"></textarea>
                            <app-form-control-messages [control]="cerificationUploadForm.get('remarkToSsc')" [name]="'Remarks to SSC'"></app-form-control-messages>
                        </div>
                    </div>

                    <hr>

                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label" style="color:red">
								Disclaimer:
								<span class="red">*</span>
							</label>
                        <div class="col-7">
                            <div class="row">
                                <p>{{disclaimer?disclaimer:"sorry could not get disclaimer"}}</p>
                            </div>
                            <div>
                                <label class="m-checkbox">
										<input type="checkbox" formControlName="declaration"> I Agree
										<span></span>
									</label>
                            </div>
                        </div>
                    </div>
                    <!-- Form Feilds Ends -->
                    <!-- Submit Button -->
                    <hr>
                    <div class="row" style="padding-bottom:30px">
                        <div style="margin-left:40%">
                            <button class="btn btn-info" *ngIf="showUpload == true" [disabled]="cerificationUploadForm.invalid || cerificationUploadForm.get('declaration').value != true" data-target="#acceptreject" (click)="onVerifyCertificate()">Submit</button>
                            <button class="btn btn-secondary" (click)="routeToList()">Cancel</button>
                        </div>
                    </div>
                    <!-- Buttons -->
                </div>
                <!-- Form Ends -->
            </div>
            <div class="modal fade" id="acceptreject" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
                <div class="modal-dialog modal-lg width-40-percent" role="document">
                    <div class="modal-content">
                        <div class="modal-header" *ngIf="availableCertificate.length > 0">
                            <h5 class="modal-title" id="exampleModalLabel" class="head_bold">
                                The applicant is already certified as {{availableCertificate[0].certificateDetails.certificateType | titlecase}} in {{availableCertificate[0].jobRoleId}}
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
									<span id="closeModal" data-dismiss="modal" aria-hidden="true">×</span>
								</button>
                        </div>
                        <div class="modal-body" style="text-align: center;">
                            <table class="table" style="width: -webkit-fill-available;">
                                <tr class="tr">
                                    <th scope="col">S.No.</th>
                                    <th scope="col">Certificate No</th>
                                    <th scope="col">QP Version</th>
                                    <th scope="col">Category</th>
                                    <th scope="col">valid Till</th>
                                </tr>
                                <tr class="tr" *ngFor="let data of availableCertificate;let i = index">
                                    <td scope="col">{{perPage * (pageNo - 1) + (i + 1)}}</td>
                                    <td scope="col">{{data.certificateDetails.certificateID ? data.certificateDetails.certificateID : 'NA' }}</td>
                                    <td scope="col">{{data.version}}</td>
                                    <td scope="col">{{getCategory(data)}}</td>
                                    <td scope="col">{{data.certificateDetails.certificateValidTillDate | date : 'dd/MM/yyyy'}}</td>

                                </tr>
                            </table>
                        </div>
                        <app-pagination [count]="count" (pageNumber)="assignPageNo($event)" [defaultRecordsPerPage]="perPage" (recordsPerPage)="assignPerPage($event)"></app-pagination>
                        <div class="modal-header align-table">
                            <p>Do you still want to submit the certificate request?</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-success" data-dismiss="modal" (click)="onSubmit()" aria-label="Close">Yes</button>
                            <button type="button" class="btn btn-danger" data-dismiss="modal" aria-label="Close" (click)="setDefaults()">No</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>